import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Matriz_FLOA, obtenerError, Perspectivas, Planificacion, procesamiento } from '../../../models/Formulacion/indicadores-metas/datos';
import Swal from 'sweetalert2';
import { MatrizFodaService } from '../../../services/formulacion/matriz-foda/matriz-foda.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { messages } from '../../funciones/mensajes';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../../services/gestion/perspectivas/perspectiva.service';
import { MatrizService, TypesMatrizEnum } from '../../../services/gestion/matriz/matriz.service';
import { getData } from '../../../services/riesgo-credito/query';
import { PERMISOS } from '../../../shared/catalogos';
@Component({
  selector: 'app-matriz-foda',
  templateUrl: './matriz-foda.component.html',
  styleUrl: './matriz-foda.component.css'
})
export class MatrizFodaComponent implements OnInit {
  public readonly permisos = PERMISOS;

  private planeacionNombre: string;
  public planeacion: Planificacion[] = [];
  public idPlanificacion: number;
  public diccionarioFLOA1: any = [];
  public diccionarioFLOA2: any = [];
  public perspectiva: Perspectivas[] = [];
  public elemento = [];
  public internos = [
    { id: 1, tipoe: 'STRENGTHS', elementoi: 'Fortalezas' },
    { id: 2, tipoe: 'WEAKNESSES', elementoi: 'Debilidades' },
  ];
  public externos = [
    { id: 3, tipoe: 'OPPORTUNITIES', elementoe: 'Oportunidades' },
    { id: 4, tipoe: 'THREATS', elementoe: 'Amenazas' },
  ];


  public idelem: number = 0;
  public tipoelem: any; //para el tipo
  public elementt: any = undefined; //para el edit
  public modal = false;
  public modal2 = false;
  public viewTablero = false;

  /** Grupo de validación de datos */
  formGeneral = new FormGroup({
    inputName: new FormControl('', [Validators.required]),
    inputNameEdit: new FormControl('', [Validators.required]),
    inputPerspective: new FormControl('', [Validators.required]),
    inputPerspectiveEdit: new FormControl('', [Validators.required]),
  }, { validators: this.nombreDuplicidad() });

  constructor(
    public dataService: DataService,
    private excelService: ExcelService,
    // private matrizService: MatrizFodaService,
    private cookies: CookieService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private perspectivaService: PerspectivaService,
    private matrizService: MatrizService
  ) {
    this.obtData();
  }

  ngOnInit(): void {

  }

  /** Obtención de datos */
  public async obtData() {
    try {
      //obtener el valor de las cookies
      const planeacionId = this.cookies.get('idInstitucion');
      const plan = await firstValueFrom(this.planificacionService.getPlanificacionById(Number(planeacionId))); 

      if (!plan) {
        return;
      }
      this.idPlanificacion = parseInt(plan.id, 10); //conversion a number

      this.planeacion = [{
        id: plan.id,
        nombre: plan.name,
        fecha_inicio: moment(plan.initial_date).toDate(),
        fecha_fin: moment(plan.end_date).toDate(),
        institucionId: plan.institution.id,
        isActive: plan.isActive
      }];

      const perspectivas = await this.perspectivaService.getPerspectivasByIdGQL(Number(plan.id));
      this.perspectiva = [];

      this.perspectiva = perspectivas
        .filter(per => Number(per.planning.id) === this.idPlanificacion)
        .map(per => ({
          nombre: per.name,
          descripcion: per.description,
          planningId: per.planning.id,
          id: per.id
        }));

      this.perspectiva = this.ordenarPerspe(this.perspectiva);
      this.diccionarioFLOA1 = this.internos.map(per => ({
        internosss: per,
        elementooo: [],
        perspectivaaa: this.perspectiva
      }));

      this.diccionarioFLOA2 = this.externos.map(per1 => ({
        externosss: per1,
        elementooo: [],
        perspectivaaa: this.perspectiva
      }));

      const floas = perspectivas.flatMap( e => {
        return e.matrix;
      });



      // const floas = await lastValueFrom(this.matrizService.getFLOA());
      this.elemento = [];

      this.procesarFLOA(this.diccionarioFLOA1, floas);
      this.procesarFLOA(this.diccionarioFLOA2, floas);

      this.elemento = this.ordenarPerspe(this.elemento);
      this.viewTablero = true;
    } catch (error) {
    }
  }

  private procesarFLOA(diccionario: any[], floas: any[]) {
    for (const per of diccionario) {
      per.elementooo = [];
      floas.forEach( (element) =>{
        const ex = per.perspectivaaa.find( p => Number(p.id) === Number(element.perspective.id));
        const ty = element.type === (per.internosss?.tipoe ?? per.externosss?.tipoe);
        
        if(ex && ty && !element.name.includes('&&')){
          per.elementooo.push({
            id: element.id,
            tipo: element.type,
            nombre: element.name,
            perspectiveId: element.perspective.id
          });
          this.elemento.push(element);
        }
      });
      per.elementooo = this.ordenarPerspe(per.elementooo);
    }
  }


  private ordenarPerspe(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  /** Metodo de deción de guardado de datos */
  public async alertas(aler?: any, ele?: any) {
    if(!aler && this.elementt){
      aler = 'editar';
    }else if(!aler && !this.elementt){
      aler = 'guardar'
    }
    if (aler === 'editar') {
      this.almacenarDatosEdit();
    } else if (aler === 'guardar') {
      this.almacenarD();
    } else if (aler === 'eliminar') {
      const result = await messages.confirmationSave(
        this.translate.instant('swal.confirmarEliminar'),
        this.translate.instant(`${ele.nombre}`),
        this.translate
      );
      if (result) {
        this.eliminarele(ele);
      }
    }
  }

  /** Refrescar los datos */
  private async actualizarDiccionarios() {
    const perspectivas = await this.perspectivaService.getPerspectivasByIdGQL(Number(this.idPlanificacion));
    const floas = perspectivas.flatMap( e => {
      return e.matrix;
    });

    this.elemento = [];

    this.procesarFLOA(this.diccionarioFLOA1, floas);
    this.procesarFLOA(this.diccionarioFLOA2, floas);

    this.elemento = this.ordenarPerspe(this.elemento);
  }

  /** Almacenamiento de los datos */
  private async guardarElemento(isEdit: boolean) {
    messages.messageSaving(this.translate.instant(isEdit?'swal.editandoInfo':'swal.agregandoInfo'),this.translate.instant('swal.espere'));
    const element = new Matriz_FLOA();
    element.tipo = TypesMatrizEnum[this.tipoelem];
    if (isEdit) {
      element.id = this.elementt.id;
      element.nombre = document.getElementById('nombreedit')['value'];
      element.perspectiveId = Number(this.formGeneral.controls['inputPerspectiveEdit'].value);
    } else {
      element.nombre = document.getElementById('nombre')['value'];
      element.perspectiveId = Number(this.formGeneral.controls['inputPerspective'].value);
    }
    this.elementt = undefined;

    if (element.nombre !== '' && element.perspectiveId !== undefined) {
      try {
        if (isEdit) {
          await firstValueFrom(this.matrizService.patchFLOA(element));
        } else {
          await firstValueFrom(this.matrizService.postFLOA(element));
        }
        // Refrescar los diccionarios
        await this.actualizarDiccionarios();
        Swal.close();
        const successMessage = isEdit ? this.translate.instant('gestion.formulacion.matrizFoda.infoActualizada') : this.translate.instant('gestion.formulacion.matrizFoda.infoAgregada');
        messages.succesMessageGraph(successMessage);
      } catch (error) {
        const er = obtenerError.errorObt(error['error'].message);
        Swal.close();
        messages.errorMessageGraph(er);
      } finally {
        this.cerrarForm();
      }
    } else {
      messages.messageGraph(
        this.translate.instant('swal.ingreseInformacion'),
        this.translate.instant(''),
        this.translate
      );
    }
  }

  public async almacenarD() {
    await this.guardarElemento(false);
  }

  public async almacenarDatosEdit() {
    await this.guardarElemento(true);
  }

  /** Eliminación de los datos */
  public async eliminarele(ele: any) {
    try {
      messages.messageSaving(this.translate.instant('swal.eliminandoInfo'),this.translate.instant('swal.espere'));
      await firstValueFrom(this.matrizService.deleteFLOA(ele));
      await this.actualizarDiccionarios();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('gestion.formulacion.matrizFoda.infoEliminada'));
    } catch (error) {
      const er = obtenerError.errorObt(error['error'].message);
      messages.errorMessageGraph(er);
    }
  }

  public mostrarElem(eleme: any, ele: any) {
    for (const obj of this.perspectiva) {
      if (Number(obj.id) === Number(ele.perspectiveId) && ele.tipo === eleme) {
        return true;
      }
    }
    return false;
  }

  // Obtención de los codigos
  public obtCodigo(inter: any) {
    switch (inter.id) {
      case 1: return 'F';
      case 2: return 'D';
      case 3: return 'O';
      case 4: return 'A';
    }
    return 'no';
  }

  /** Modales */
  // Abrir
  public abrirFormAgregar(elem: any, elemento1: any) {
    this.formGeneral.controls['inputPerspective'].setValue('default'); //para que siempre se muestre la opcion por default
    this.idelem = elem.id;
    this.tipoelem = elem.tipoe;
    // document.getElementById('formularionuevo')!.style.display = 'block';
    this.modal = true;
  }
  public abrirFormEdit(ele: any, eleme: any) {
    this.modal2 = true;
    this.elementt = ele;
    this.idelem = eleme.id;
    this.formGeneral.controls['inputNameEdit'].setValue(this.elementt.nombre);
    this.formGeneral.controls['inputPerspectiveEdit'].setValue(this.elementt.perspectiveId);
    // document.getElementById('formularioedit')!.style.display = 'block'
  }
  // Cerrar
  public cerrarForm() {
    this.modal = false;
    this.modal2 = false;
    // document.getElementById('formularionuevo')!.style.display = 'none'
    // document.getElementById('formularioedit')!.style.display = 'none'

    this.formGeneral.reset({
      inputName: '',
      inputPerspective: 'default'
    });
  }

  /** Exportación */
  public exportar_excel() {
    let title = this.translate.instant('gestion.formulacion.matrizFoda.tituloExcel');
    let subtituloElementosInternos = this.translate.instant('gestion.formulacion.matrizFoda.elementosInternos');
    let headersInternos = [];
    let elementosInternos = [];
    for (let i = 0; i < this.diccionarioFLOA1.length; i++) {
      let header = [];
      headersInternos.push('#');
      headersInternos.push(this.diccionarioFLOA1[i].internosss.elementoi);
      headersInternos.push('');
      // headersInternos.push(header);
      let elemento = [];
      for (let j = 0; j < this.diccionarioFLOA1[i].elementooo.length; j++) {
        let col1 = this.obtCodigo(this.diccionarioFLOA1[i].internosss).concat('' + (j + 1));
        elemento.push([col1, this.diccionarioFLOA1[i].elementooo[j].nombre]);

      }

      elementosInternos.push(elemento);
    }

    let subtituloElementosExternos = this.translate.instant('gestion.formulacion.matrizFoda.elementosExternos');
    let headersExternos = [];
    let elementosExternos: any = [];
    for (let i = 0; i < this.diccionarioFLOA1.length; i++) {
      let header = [];
      headersExternos.push('#');
      headersExternos.push(this.diccionarioFLOA2[i].externosss.elementoe);
      headersExternos.push('');
      let elemento = [];
      for (let j = 0; j < this.diccionarioFLOA2[i].elementooo.length; j++) {
        let col1 = this.obtCodigo(this.diccionarioFLOA2[i].externosss).concat('' + (j + 1));
        elemento.push([col1, this.diccionarioFLOA2[i].elementooo[j].nombre]);
      }
      elementosExternos.push(elemento);
    }

    this.excelService.generateExcelMatrizFoda(title, headersInternos, headersExternos, elementosInternos, elementosExternos, 'matriz_foda', subtituloElementosInternos, subtituloElementosExternos);
  }

  /** Desición de guardado */
  public puede_guardar() {
    var element = new Matriz_FLOA();
    element.tipo = undefined;
    element.nombre = this.formGeneral.controls['inputName'].value;
    element.perspectiveId = Number(this.formGeneral.controls['inputPerspective'].value);
    const perspectivaValue = this.formGeneral.controls['inputPerspective'].value; // <-- valor original (string)

    if (element.nombre != '' &&  perspectivaValue !== 'default'  && element.perspectiveId != 0 && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }
  public puede_guardarEdit() {
    var element = new Matriz_FLOA();
    element.tipo = undefined;
    element.nombre = this.formGeneral.controls['inputNameEdit'].value;
    element.perspectiveId = Number(this.formGeneral.controls['inputPerspectiveEdit'].value);
    if (element.nombre != '' && element.perspectiveId != 0 && !this.nombreExiste()) {
      return ''
    }
    return 'w3-disabled'
  }

  public clickFuera(event, modal){
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      },600);
    }
  }

  /** Comprobación de que el nombre no exista*/
  private nombreDuplicidad(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var nombre = formGroup.get('inputName').value.trim().toLowerCase();

      if(!nombre) {return null;}

      const existe = this.elemento.some( el => {
        const exName = el.name.trim().toLowerCase();
        if(this.elementt){
          return ( exName === nombre && el.id !== this.elementt.id);
        }else{
          return exName === nombre;
        }
      });

      if (existe) return { isValid: true };

      return null;
    };
  }
  public nombreExiste(): boolean {
    return this.formGeneral.hasError('isValid');
  }

}
